import _ from 'lodash';
import { createSelector } from 'reselect';

const selToasts = state => state.toast.toasts;

export default {
  toasts: selToasts,
};
